"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormat = void 0;
var DateFormat;
(function (DateFormat) {
    DateFormat["FULL"] = "yyyy/MM/dd HH:mm:ss";
    DateFormat["DATE"] = "yyyy/MM/dd";
    DateFormat["TIME"] = "HH:mm:ss";
})(DateFormat || (exports.DateFormat = DateFormat = {}));
